import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { translate } from 'react-i18next'
import { connect } from 'react-redux'
import _ from 'lodash'

import Select from '../Select/Select'
import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'

const ALL = 'all'

class HierarchySelect extends Component {
  static propTypes = {
    concatId: PropTypes.bool,
    field: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    query: PropTypes.object,
    translate: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    isMulti: PropTypes.bool,
    noOptions: PropTypes.bool,
    value: PropTypes.any,
    label: PropTypes.string,
    required: PropTypes.bool,
  }

  state = {
    options: [],
    error: null,
    loading: true,
  }

  componentDidMount() {
    this.fetchDataSelected()
  }

  componentDidUpdate(prevProps) {
    const { query = {} } = this.props

    if (!_.isEqual(query, prevProps.query)) {
      this.fetchDataSelected()
    }
  }

  fetchDataSelected = async () => {
    const { query, user } = this.props

    this.setState({ options: [] })

    if (query.sectionIdList) {
      if (Array.isArray(query.sectionIdList)) {
        const sectionIdList = query.sectionIdList.reduce((acc, { value }) => {
          if (value !== ALL) {
            return [...acc, value]
          }

          return [...acc]
        }, [])

        const { data } = await this.callApi(user.dsToken, { sectionIdList })
        this.setState((state) => ({ options: [...state.options, ...data] }))
      } else {
        const sectionArrayId = Object.values(query.sectionIdList)
        const sectionIdList = [query.sectionIdList.value]
        const sectionIdListArray = sectionArrayId.reduce((acc, { value }) => {
          if (value !== ALL) {
            return [...acc, value]
          }

          return [...acc]
        }, [])


        const { data } = await this.callApi(user.dsToken, { sectionIdList: sectionIdListArray || sectionIdList })
        this.setState((state) => ({ options: [...state.options, ...data] }))
      }
    }

    this.setState({ loading: false })
  }

  callApi = (token, params) => {
    this.setState({ loading: true })

    return new Api(token).get(API_URL.FIND_SUBSECTIONS, params)
  }

  onFetchSuccess = (options) => {
    this.setState({ options, loading: false, error: null })
  }

  onFetchError = (error) => {
    this.setState({ error, loading: false, options: [] })
  }

  renderOptions = () => {
    const { concatId, field = 'sectionId' } = this.props

    let options

    if (concatId) {
      options = this.state.options
        .map((option) => ({
          value: option[field],
          label: `${option[field]} - ${option.description}`,
          level: option.level,
          ...option,
        }))
        .sort((prev, next) => prev.value - next.value)
    } else {
      options = this.state.options.map((option) => ({
        value: option[field],
        label: option.description,
        level: option.level,
        ...option,
      }))
    }

    return options
  }

  setValue = (value, query) => {
    const { options } = this.state

    let option
    switch (query.level) {
      case 2:
        option = options.find((option) => option.sectionId === value)
        return this.returnValue(value, option && option.description)
      case 3:
        option = options.find(
          (option) =>
            option.sectionId === query.sectionId &&
            option.subSectionId === value
        )
        return this.returnValue(value, option && option.description)
      case 4:
        option = options.find(
          (option) =>
            option.sectionId === query.sectionId &&
            option.subSectionId === query.subSectionId &&
            option.typeId === value
        )
        return this.returnValue(value, option && option.description)
      case 5:
        option = options.find(
          (option) =>
            option.sectionId === query.sectionId &&
            option.subSectionId === query.subSectionId &&
            option.typeId === query.typeId &&
            option.subTypeId === value
        )
        return this.returnValue(value, option && option.description)
      default:
        return null
    }
  }

  returnValue = (value, description) => {
    const { concatId } = this.props

    return concatId
      ? { value, label: `${value} - ${description}` }
      : { value, label: description }
  }

  handleChange = (selectedOptions) => {
    const { onChange } = this.props

    if (Array.isArray(selectedOptions)) {
      if (selectedOptions.some((option) => option.value === ALL)) {
        onChange(this.renderOptions())
        return
      }
    } else if (!selectedOptions) {
      onChange({ value: '' })

      return
    }

    onChange(selectedOptions)
  }

  render() {
    const {
      placeholder,
      translate,
      query,
      disabled = false,
      isMulti = false,
      noOptions,
      value,
      label,
      required,
      ...props
    } = this.props

    const options = this.renderOptions()

    let newValue = value

    const { loading } = this.state

    if (
      Array.isArray(newValue) &&
      newValue.length &&
      typeof newValue[0] === 'number'
    ) {
      newValue = newValue.map((cdSection) =>
        options.find((option) => option.sectionId === cdSection)
      )
    }

    if (typeof newValue === 'number') {
      newValue = this.setValue(newValue, query)
    }

    return (
      <Select
        {...props}
        options={noOptions ? [] : options}
        placeholder={translate(loading ? 'irc.loading' : placeholder)}
        disabled={loading ? true : disabled}
        isMulti={isMulti}
        translate={translate}
        groupOptions
        selectAll
        label={label}
        required={required}
        onChange={this.handleChange}
        value={newValue}
        validateValue={(val) =>
          isMulti ? val && val.length > 0 : Boolean(val)
        }
      />
    )
  }
}

const mapStateToProps = ({ auth }) => ({
  user: auth.user,
})

/*
 * Connects component to I18next
 */
const SectionSelectTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(HierarchySelect)

/*
 * Exports component connected to redux
 */
export default connect(mapStateToProps)(SectionSelectTranslated)

/*
 * Exports component only
 */
export { HierarchySelect as SectionSelect }
